
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facilities/[facility]",
      function () {
        return require("private-next-pages/facilities/[facility].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facilities/[facility]"])
      });
    }
  